import { get, post } from "./common/http";
import { BASE_URL } from "./common/const";
import { GET_ENC, POST_ENC } from "./common/EncryptedHttp";
 
 

export const GetProductCompanyList = (params: any) =>
   GET_ENC(`${BASE_URL}/api/ProductCompany/GetList?` + params, null);

export const GetProductCompanyDetail = (params: any) =>
   GET_ENC(`${BASE_URL}/api/ProductCompany/GetDetail?` + params, null);

export const CreateProductCompany = (data: any) =>
  POST_ENC(`${BASE_URL}/api/ProductCompany/Create`, data);

export const UpdateProductCompany = (data: any) =>
  POST_ENC(`${BASE_URL}/api/ProductCompany/Update`, data);

export const DeleteProductCompany = (data: any) =>
  POST_ENC(`${BASE_URL}/api/ProductCompany/Delete`, data);